import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css'
import { CancelButton, DBDropDownObjective, DBTextFieldObjective, DBDateField, DBTextField, DBDropDown, CopyButton } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';

class PedsGoalsRow extends React.Component {
    deleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
    }
    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }
    deleteExistGoal() {
        // this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', true);
        // if (!this.props.goalsUpdated) {
        //     this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        // }
    }
    render() {

        return (
            <PatientCareCenterNoteNavAnchor id={'goal_' + this.props.id} >
                <div className={styles.peds_goal_section}>
                    <div className={styles.peds_current_row}>
                        <span className={styles.goal_detail_col1}>
                            {/* always allow custom goals to be deleted*/}
                            <CancelButton title='Delete Goal' size='extra-small' onClick={() => this.deleteGoal()} />
                        </span>
                        {/* Activity */}
                        {this.props.isCustom &&
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.id}
                                field='GOCUSTOM'
                                disabled={this.props.existingGoal}
                                className={styles.peds_textbox}

                            />

                        }
                        {!this.props.isCustom &&
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.id}
                                field='GOMGNO'
                                className={styles.peds_ddl}
                                masterEntity='PTMASTERGOALS'
                                masterEntityKeyColumn='MGNO'
                                masterEntitySort='MGORDER'
                                masterEntityDisplay='MGNAME'
                                disabled={this.props.existingGoal}
                                customOptions={this.props.ptMasterPedsOptions}
                            />
                        }
                        <span className={styles.peds_label}>Current</span>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.id}
                            field='GOLONOCURRENT'
                            className={styles.peds_ddl}
                            masterEntity='PTMASTERGOALLOA'
                            masterEntityKeyColumn='LONO'
                            masterEntitySort='LOORDER'
                            masterEntityDisplay='LOSENTENCETXT'
                            customOptions={this.props.loaOptions}
                        />
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.id}
                            field='GOCURRENTDESC'
                            className={styles.peds_txt}
                        />
                        {this.props.noteType !== 1 && (!this.props.isPeds && this.props.isPedsEnabled) &&
                            <>
                                <span className={styles.peds_prog_label}>Progress</span>
                                <DBDropDown
                                    className={this.props.progReq ? styles.ltg_goal_prog_dropdown_req : styles.ltg_goal_prog_dropdown}
                                    noteId={this.props.noteId}
                                    entity='PTGOALS'
                                    entityKeyColumn='GONO'
                                    entityKeyValue={this.props.id}
                                    field='GOGPNO'
                                    masterEntity='PTMASTERGOALPROGRESS'
                                    masterEntityKeyColumn='GPNO'
                                    masterEntitySort='GPORDER'
                                    masterEntityDisplay='GPNAME'
                                    disabled={this.props.progDisabled}
                                    onChange={() => this.goalValueChanged()}
                                />
                                {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                    <div className={styles.goal_detail_copy_col}>
                                        <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyProgress()} />
                                    </div>
                                }
                            </>
                        }


                    </div>
                    <div className={styles.peds_current_row}>
                        <span className={styles.goal_detail_col1} />
                        <span className={styles.peds_ddl} />
                        <span className={styles.peds_label}>Goal</span>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.id}
                            field='GOLONOGOAL'
                            className={styles.peds_ddl}
                            masterEntity='PTMASTERGOALLOA'
                            masterEntityKeyColumn='LONO'
                            masterEntitySort='LOORDER'
                            masterEntityDisplay='LOSENTENCETXT'
                            disabled={this.props.existingGoal}
                            customOptions={this.props.loaOptions}
                        />
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.id}
                            field='GOOBJECTIVE'
                            disabled={this.props.existingGoal}
                            className={styles.peds_txt}
                        />

                        <span className={styles.peds_prog_label}>Date</span>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.id}
                            field='GODATE'
                            customMsg='The goal date cannot be in the past.'
                            disabled={this.props.dateDisabled}
                            minDate={getDateMMDDYYYY(new Date())}
                            defaultdate={this.props.days}
                        />

                    </div>

                </div>
            </PatientCareCenterNoteNavAnchor>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),

    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let days = ownprops.days;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled;
    let goals = state.entities.notes.PTGOALS[ownprops.id];
    let isCustom = (goals.GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE));
    let existingGoal = false;
    let goalPreviouslyMet = false;


    if (state.entities.notes.PTGOALS[ownprops.id].GOGPNOPREV === 11) {
        goalPreviouslyMet = true;
    }

    let dateDisabled = noteType === 2 || noteType === 4 || noteType === 6 || goalPreviouslyMet ? true : false;

    if (goals.GOGONO || goals.GOCWSGOAL) {
        existingGoal = true;
    }


    let ptMasterPedsOptions = Object.keys(state.entities.masterData.PTMASTERGOALS)
        .filter(key => {
            return (
                state.entities.masterData.PTMASTERGOALS[key].MGPEDS &&
                state.entities.masterData.PTMASTERGOALS[key].MGSPEECH === isSpeech
            );
        })
        .map(key => ({
            id: state.entities.masterData.PTMASTERGOALS[key].MGNO,
            value: state.entities.masterData.PTMASTERGOALS[key].MGNAME
        }))
        .filter(item => ![189, 190, 191].includes(item.id));

    let loaOptions = Object.keys(state.entities.masterData.PTMASTERGOALLOA)
        .filter(key => {
            return (
                state.entities.masterData.PTMASTERGOALLOA[key].LOISPEDS
            )
        })
        .sort((a, b) => {
            return state.entities.masterData.PTMASTERGOALLOA[a].LOORDER - state.entities.masterData.PTMASTERGOALLOA[b].LOORDER;
        })
        .map(key => {
            return {
                id: state.entities.masterData.PTMASTERGOALLOA[key].LONO,
                value: state.entities.masterData.PTMASTERGOALLOA[key].LONAME,
            }
        });


    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;

    return {
        noteId,
        ptMasterPedsOptions,
        days,
        loaOptions,
        isCustom,
        existingGoal,
        pk,
        dateDisabled,
        isPeds,
        isPedsEnabled,
        noteType
    };
}

const connectedPedsGoalsRow = connect(mapStateToProps, mapDispatchToProps)(PedsGoalsRow);
export { connectedPedsGoalsRow as PedsGoalsRow };

